import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Button,
  Typography,
  Tab,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import dummyImg from "../../../../../assets/images/Picture1.png";
import { apiService } from "../../../../api/apiService";
import BusinessDescription from "./Admin-End/ModalComponent/BusinessDescription";
import KPIBasket from "./Admin-End/ModalComponent/KPIBasket";
import CriticalMatrix from "./Admin-End/ModalComponent/CriticalMatrix";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";

interface SipocModalProps {
  open: boolean;
  onClose: () => void;
  sipocId: string | null;
  functionL1: any;
  functionL2: any;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const SipocModal: React.FC<SipocModalProps> = ({
  open,
  onClose,
  sipocId,
  functionL1,
  functionL2,
}) => {
  const { instance } = useMsal();
  const [value, setValue] = useState(
    () => localStorage.getItem("currentTab") || "1",
  );

  const [showInput, setShowInput] = useState(false);
  const [approveHidden, setApproveHidden] = useState(false);
  const [revertHidden, setRevertHidden] = useState(false);

  const [backgroundColor, setBackgroundColor] = useState("#e6ffed"); // Default background color for Approve
  const [clickCount, setClickCount] = useState(0);
  const [sipocData, setSipocData] = useState<any | null>(null);
  const [imagePreview, setImagePreview] = useState<any | null>(null);
  const [slafilePreview1, setSlafilePreview1] = useState<any | null>(null);
  const [slafilePreview2, setSlafilePreview2] = useState<any | null>(null);

  const [loading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);

  const totalTabs = 5;

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    // resetStateForTab();
  };

  const handleNextTab = () => {
    setValue((prevValue) => {
      const nextValue = (parseInt(prevValue) % totalTabs) + 1;
      return nextValue.toString();
    });
    // resetStateForTab();
  };

  const handlePrevTab = () => {
    setValue((prevValue) => {
      const prevValueNum = parseInt(prevValue);
      const newValue = prevValueNum === 1 ? totalTabs : prevValueNum - 1;
      return newValue.toString();
    });
  };

  const pageNames = [
    "Business Description",
    "Job Hierarchy",
    "KPI Basket",
    "Critical Matrix",
    "SLA",
  ];

  const isLastTab = value === totalTabs.toString();

  const fetchBusinessDescription = async () => {
    try {
      // Fetch the business description
      const result = await apiService(
        `/management/business_description/${sipocId}`,
        "GET",
        undefined,
        undefined,
        instance as PublicClientApplication,
      );
      console.log("Fetched SIPOC Data:", result.data);

      // Update the state with the fetched data
      setSipocData(result.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchJobHierarchyData = async () => {
    // Extract the doc_path from the response
    const jobDocPath = sipocData.job_hierarchy_data?.doc_path;

    if (jobDocPath) {
      // Call the second API with the doc_path
      const downloadResult = await apiService(
        `/download?doc_path=${encodeURIComponent(jobDocPath)}`,
        "GET",
        undefined,
        undefined,
        instance as PublicClientApplication,
      );
      console.log("Downloaded Document Data:", downloadResult.data);

      // Check if the downloadResult contains the expected data
      if (downloadResult.data) {
        setImagePreview(downloadResult.data);
        console.log("imagePreview set to:", downloadResult.data);
      } else {
        console.warn("No data found in downloadResult.");
      }
    } else {
      console.warn("doc_path not found in job_hierarchy_data.");
    }
  };

  const fetchSLA = async () => {
    try {
      const slaFile1Path =
        sipocData.bd_sla?.services_with_the_customer_doc_path;
      const slaFile2Path = sipocData.bd_sla?.plans_for_the_missed_sla_doc_path;

      // Create an array of promises for the API calls
      const apiCalls = [
        apiService(
          `/download?doc_path=${encodeURIComponent(slaFile1Path)}`,
          "GET",
        ),
        apiService(
          `/download?doc_path=${encodeURIComponent(slaFile2Path)}`,
          "GET",
        ),
      ];

      // Execute the API calls concurrently
      const [slaFile1Result, slaFile2Result] = await Promise.all(apiCalls);

      // Set the slaFilePreview1 state with the downloaded data
      setSlafilePreview1(slaFile1Result.data);

      // Set the slaFilePreview2 state with the downloaded data
      setSlafilePreview2(slaFile2Result.data);

      console.log(
        "Downloaded SLA Document Data:",
        slaFile1Result.data,
        slaFile2Result.data,
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (!sipocId || !open) return;
    fetchBusinessDescription();
  }, [sipocId, open]);

  if (!sipocData) {
    return null; // Render nothing or a loading state while fetching data
  }

  const {
    business_desc_data: businessDescData,
    kpiBasketList,
    critical_matrices: criticalMatrices,
    job_hierarchy_data: jobHierarchyData,
    bd_sla: bdSlaData,
  } = sipocData; // Destructure the data

  console.log("sipocData sipocData", sipocData.critical_matrices);

  // console.log('sipocData sipocData', sipocData.bd_stage)
  // console.log('sipocData sipocData', sipocData.job_hie_stage)
  // console.log('sipocData sipocData', sipocData.kpi_basket_stage)
  // console.log('sipocData sipocData', sipocData)
  // console.log('bdSlaData', bdSlaData)

  const isStatusApprovedOrReverted = (status: string) => {
    return status === "Approved" || status === "Reverted";
  };

  const getStatusForCurrentTab = () => {
    switch (parseInt(value)) {
      case 1:
        // return businessDescData.status;
        return sipocData.bd_stage;
      case 2:
        // return jobHierarchyData.status;
        return sipocData.job_hie_stage;
      case 3:
        // return kpiBasketList[0].status;
        return sipocData.kpi_basket_stage;
      case 4:
        // return criticalMatrices[0].status;
        return sipocData.critical_matrix_stage;
      case 5:
        // return criticalMatrices[0].status;
        return sipocData.sla_stage;
      default:
        return "";
    }
  };
  const currentStatus = getStatusForCurrentTab();

  console.log("currentStatus", currentStatus);

  // const currentReason = getReasonForCurrentTab();

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition>
      <Slide in={open} direction="left">
        <Box
          className="sipocmodald"
          sx={{
            width: 1000,
            padding: 4,
            position: "absolute",
            top: "0%",
            right: "1%",
            backgroundColor: "white",
            boxShadow: 24,
            borderRadius: 2,
            outline: 0,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Business Description
          </Typography>
          <Box display="flex" gap={1}>
            <Typography variant="body1">Filter:</Typography>
            <Typography variant="body1">{functionL1}, </Typography>
            <Typography variant="body1">{functionL2}</Typography>
          </Box>

          <TabContext value={value}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                paddingTop: "15px",
              }}
            >
              <TabList onChange={handleChange} aria-label="modal tabs">
                <Tab label="Business Description" value="1" />
                <Tab
                  label="Job Hierarchy"
                  value="2"
                  onClick={fetchJobHierarchyData}
                />
                <Tab label="KPI Basket" value="3" />
                <Tab label="Critical Matrix" value="4" />
                {/* <Tab label="SLA" value="5" onClick={fetchSLA} /> */}
              </TabList>
            </Box>

            {/* Business Description Tab */}
            <TabPanel value="1">
              <BusinessDescription businessDescData={businessDescData} />
            </TabPanel>

            {/* Job Hierarchy Tab */}
            <TabPanel value="2">
              <Typography variant="h6">Job Hierarchy</Typography>

              <DialogContent sx={{ overflowY: "hidden", padding: "0" }}>
                {loading ? (
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress />
                    <Typography variant="body2" sx={{ mt: 2 }}>
                      Loading image...
                    </Typography>
                  </div>
                ) : error ? (
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                ) : imagePreview ? (
                  <>
                    {imagePreview.startsWith("JVBERi0") ? ( // Check if the base64 string is a PDF
                      <iframe
                        src={`data:application/pdf;base64,${imagePreview}`}
                        width="100%"
                        height="500px"
                        title="PDF Preview"
                      />
                    ) : (
                      <img
                        src={`data:image/png;base64,${imagePreview}`}
                        alt="Job Hierarchy"
                        style={{
                          width: "100%",
                          height: "500px",
                          paddingTop: "20px",
                          objectFit: "contain",
                        }}
                      />
                    )}
                  </>
                ) : null}
              </DialogContent>
            </TabPanel>

            {/* KPI Basket Tab */}
            <TabPanel value="3">
              <KPIBasket kpiBasketList={kpiBasketList} />
            </TabPanel>
            {/* tab for Critical Matrix */}
            <TabPanel value="4">
              <CriticalMatrix criticalMatrices={criticalMatrices} />
            </TabPanel>

            {/* <TabPanel value="5" >
            <Typography variant="h6">SLA</Typography>


            <Box sx={{ display: 'flex', gap: '30px', paddingTop: '10px' }}>
              <DialogContent sx={{ overflowY: 'hidden', padding: '0', flex: 1, height: '250px' }}>
                {loading ? (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                    <Typography variant="body2" sx={{ mt: 2 }}>
                      Loading image...
                    </Typography>
                  </div>
                ) : error ? (
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                ) : slafilePreview1 ? (
                  <>
                    {slafilePreview1.startsWith('JVBERi0') ? ( // Check if the base64 string is a PDF
                      <iframe
                        src={`data:application/pdf;base64,${slafilePreview1}`}
                        width="100%"
                        height="100%"
                        title="PDF Preview"
                      />
                    ) : (
                      <img
                        src={`data:image/png;base64,${slafilePreview1}`}
                        alt="Job Hierarchy"
                        style={{ width: '100%', height: '280px', paddingTop: '20px' }}
                      />
                    )}
                  </>
                ) : null}
              </DialogContent>

              <DialogContent sx={{ overflowY: 'hidden', padding: '0', flex: 1, height: '250px' }}>
                {loading ? (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                    <Typography variant="body2" sx={{ mt: 2 }}>
                      Loading image...
                    </Typography>
                  </div>
                ) : error ? (
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                ) : slafilePreview2 ? (
                  <>
                    {slafilePreview2.startsWith('JVBERi0') ? ( // Check if the base64 string is a PDF
                      <iframe
                        src={`data:application/pdf;base64,${slafilePreview2}`}
                        width="100%"
                        height="100%"
                        title="PDF Preview"
                      />
                    ) : (
                      <img
                        src={`data:image/png;base64,${slafilePreview2}`}
                        alt="Job Hierarchy"
                        style={{ width: '100%', height: '280px', paddingTop: '20px' }}
                      />
                    )}
                  </>
                ) : null}
              </DialogContent>
            </Box>
          </TabPanel> */}
          </TabContext>

          {/* status approved and removed functinality */}

          <div>
            <Box
              className="modalfooter"
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              <Button className="Footerbtn1" onClick={handlePrevTab}>
                Previous
              </Button>

              <div className="flex-item actionbtnsmodal">
                <>
                  <Button
                    className="Footerbtn3"
                    onClick={isLastTab ? onClose : handleNextTab}
                  >
                    {isLastTab ? "Close" : "Next Tab"}
                  </Button>
                </>
              </div>
            </Box>
          </div>
        </Box>
      </Slide>
    </Modal>
  );
};
export default SipocModal;
function setError(arg0: string) {
  throw new Error("Function not implemented.");
}
